<template>
  <el-scrollbar max-height="25rem" class="ai-content-scrollbar-container"
    ref="scrollbarRef"
    @wheel="wheelFn"
  >
    <div
      class="marked-change-content"
      v-html="marked(aiContent)"
    ></div>
    <div v-if="textloading" class="text-loading-content">
      <svg-icon iconName="loading"></svg-icon>
    </div>
  </el-scrollbar>
</template>

<script setup>
import { 
  onBeforeMount, onMounted, onUnmounted, onUpdated,
  computed, watch, ref, nextTick, reactive, markRaw,
  h, defineComponent, toRaw,
} from 'vue';

import store from '@/store';
import { isNull, dayjs, message, vueCreateAppInit } from '@/utils/js/initVariable';

import SvgIcon from '@/components/SvgIcon';
import { fetchEventSourceInit, } from '@/api/fetchInit';
import { marked } from 'marked';

// props
const props = defineProps({
  url: { type: String, required: true, },
  headers: { type: Object, }, 
  data: { type: Object, },
});
// emit
const emit = defineEmits([
  
]);

// 组件挂载前
onBeforeMount(()=>{

});
// 组件挂载后
onMounted(()=>{
  fetchEventSourceInitFn();
});
// 组件更新后
onUpdated(()=>{

});
// 组件销毁后
onUnmounted(()=>{
  controllerClose();
});

const textloading = ref(true),
      textloadingChange = (flag)=>{
        textloading.value = flag;
      }

const scrollbarRef = ref(), 
scrollToBottom = ()=>{
  const scrollbar = scrollbarRef.value;
  if(!scrollbar)return
  scrollbar.setScrollTop(
    scrollbar.wrapRef.scrollHeight
  )
}
let isScrollbar = false,
isScrollbarChange = (flag)=>{
  isScrollbar = flag;
},
isNotWheelTime, isNotWheelTimeFlag = true,
isNotWheelFn = ()=>{
  isNotWheelTime && clearTimeout(isNotWheelTime);
  isNotWheelTime = setTimeout(()=>{
    isScrollbarChange(false);
  }, 3 * 1000);
},
wheelFn = ()=>{
  isScrollbarChange(true);
  !isNotWheelTimeFlag && isNotWheelFn();
}

const aiContent = ref('');
let controller,
controllerClose = ()=>{
  if(controller){
    controller.abort();
    controller = undefined;
  }
}
function formatMarkdownText(text) {
    return text
        .replace(/([#*])([^#*\s])/g, '$1 $2')  // 在格式符号后添加空格
        .replace(/\*\*(\S)/g, '** $1')         // 粗体符号后加空格
        .replace(/(\S)\*\*/g, '$1 **');        // 粗体符号前加空格
}
const fetchEventSourceInitFn = ()=>{
  controllerClose();
  isScrollbarChange(false);
  textloadingChange(true);

  controller = new AbortController();
  fetchEventSourceInit(props.url, props.headers, props.data, {
    signal: controller.signal,
    openWhenHidden: true,
    onopen: (response)=>{
      // if(!response.ok){
      //   controllerClose();
      // }
      textloadingChange(false);
    },
    onmessage: (event) => {
      // 检查是否是流结束标志[citation:8]
      if (event.data === '[DONE]') {
        isNotWheelTimeFlag();
        controllerClose();
        return;
      }
      try {
        // 解析接收到的数据
        const data = JSON.parse(event.data);
        // console.log(data);
        // 提取AI返回的文本内容
        // 注意：不同AI接口返回的数据结构可能不同
        let content = data.content;

        // 累积消息内容
        if (content) {
          aiContent.value += content ;
          // 自动滚动到底部
          nextTick(() => {
            !isScrollbar && scrollToBottom();
          });
        }
      } catch (error) {
        console.error('解析消息错误:', error);
      }
    },
    onerror: (err)=>{
      controllerClose();
      textloadingChange(false);
    }
  })
}

</script>

<style lang='less'>

</style>

<style lang='less' scoped>
.ai-content-scrollbar-container{
  .text-loading-content{
    text-align: center;
  }
}
</style>